export const reportOptions = [
  { label: "Call of Visit Report", value: "call_of_visit" },
  { label: "Daily Carer Allocation Report", value: "daily_carer_allocation" },
  { label: "GeoFence Report", value: "geofence" },
  { label: "Housepack", value: "housepack" },
  { label: "Meds Administration Report", value: "meds_administration" },
  {
    label: "Service User Template Visit Schedule Report",
    value: "service_user_template",
  },
  { label: "Service User Time Analysis", value: "service_user_time_analysis" },
  { label: "Service User Visit Report", value: "service_user_visit" },
  { label: "Spoof Report", value: "spoof_report" },
  { label: "Visit Detail Report", value: "visit_detail" },
];
